<template>
    <v-fade-transition>
        <v-sheet class="container elevation-5">

            <input :value="value"
                   ref="digitInput"
                   @keydown.prevent="inputChanged"
                   size="1"
                   maxlength="1"
                   inputmode="numeric"
                   pattern="[0-9]*"
                   type="text"
                   class="display-2 box"
            />

        </v-sheet>
    </v-fade-transition>
</template>

<script>

    export default {

        data() {
            return {
                value: null
            }
        },

        methods: {
            inputChanged(event) {

                if (event.key==='Backspace') {
                    this.value='';
                    this.$emit('delete');
                    return;
                }

                const value = parseInt(event.key);

                    if (!isNaN(value) && event.key >= 0) {
                        this.value = value;
                        this.$emit('change', value);
                    } else {
                        this.value = '';
                    }
            },
        }
    }
</script>

<style scoped>

    .box {
        margin-left: 10px;
        margin-top: 5px;
        width: 100%;
        color: white;
    }

    .container {
        margin: 2px;
        background-color: #999;
        padding: 0px;
        width: 50px;
        height: 60px;
    }

    input:focus {
        outline: none;
    }

</style>
